<template>
  <div
    v-for="item in list"
    :key="item.label"
    class="flex justify-between my-2"
    :class="{ [fontSize]: fontSize, [margin]: margin }"
  >
    <template v-if="item?.totalPrice?.inCents !== 0">
      <div class="flex items-center">
        <span data-test-id="price-details__price-item-description">{{ item.label }}</span>
        <CleaningFeeTooltip v-if="item.label === 'Cleaning fee'" />
      </div>
      <div data-test-id="price-details__price-item-amount">
        {{ item.totalPrice.formatted }}
      </div>
    </template>
  </div>
</template>

<script>
import CleaningFeeTooltip from '@/components/Ui/CleaningFeeTooltip.vue';

export default {
  components: { CleaningFeeTooltip },
  props: {
    list: {
      type: Array,
      required: true,
    },
    fontSize: String,
    margin: String,
  },
};
</script>

<style lang="scss">

</style>
